// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1767":"12c5327b","2745":"9ec9c0c2","2915":"fc1e0a10","3036":"9ec9c0c2","5223":"6822c59d","6346":"cc00fa56","7045":"cb11b560","8475":"b9781c11"}[chunkId] + ".chunk.css";
};